import React, { useState } from 'react';
import { useDispatch } from 'react-redux';

import { Button, Col, Form, Input, Row, message } from 'antd';

import { bulkDocUpdateCreate } from 'app/redux/actions/initiatives';

const RelatedDocsForm = ({ docsList, initiativeID }) => {
  const dispatch = useDispatch();

  const [errorMessage, setErrorMessage] = useState(null);

  const [inputFields, setInputFields] = useState(() => {
    if (docsList?.length > 0)
      return docsList.map(obj => {
        const document = obj?.node;
        return {
          pk: document.pk,
          title: document?.title,
          fileURL: document?.file,
        };
      });
    else
      return [
        {
          title: '',
          file: '',
        },
      ];
  });

  const handleFormChange = (index, event) => {
    let data = [...inputFields];
    data[index][event.target.name] =
      event.target.name === 'file' ? event.target.files[0] : event.target.value;
    setInputFields(data);
  };

  const addFields = () => {
    const newField = { title: '', file: '' };
    setInputFields([...inputFields, newField]);
  };

  const removeFields = async index => {
    let data = [...inputFields];
    data.splice(index, 1);
    setInputFields(data);
  };

  const onFinish = async () => {
    const response = await dispatch(
      bulkDocUpdateCreate(initiativeID, inputFields),
    );

    if (typeof response === 'string' && response.includes('Error'))
      setErrorMessage(response);
    else {
      setErrorMessage(null);

      message.config({
        top: 0, // push to the top
      });

      message.success({
        content: 'Updated Successfully',
        duration: 2, // Displays the success message for 2 seconds
      });

      // Wait for the success message to disappear before reloading
      setTimeout(() => {
        window.location.reload();
      }, 2000); // Matches the duration of the success message
    }
  };

  return (
    <Form onFinish={onFinish}>
      {errorMessage && <p className="text-error">{errorMessage}</p>}

      <p className="font-weight-bold text-error">
        - Maximum allowed size for a file: 1 MB.
      </p>

      <Form.List name="relatedDocsForm" initialValue={inputFields}>
        {(fields, { add, remove }) => (
          <>
            {fields.map((field, index) => (
              <Row gutter={[8, 8]} key={field.key}>
                <Col md={10} xs={24}>
                  <Form.Item
                    name={[index, 'title']}
                    label="Title"
                    rules={[{ required: true, message: "'title' is required" }]}
                  >
                    <Input
                      name="title"
                      onChange={event => handleFormChange(index, event)}
                    />
                  </Form.Item>
                </Col>

                <Col md={10} xs={24}>
                  <Form.Item
                    name={[index, 'file']}
                    label="File"
                    rules={[
                      {
                        required: !('pk' in inputFields[index]),
                        message: "'file' is required",
                      },
                    ]}
                    className="mb-0"
                  >
                    <input
                      name="file"
                      type="file"
                      onChange={event => handleFormChange(index, event)}
                    />
                  </Form.Item>

                  {'fileURL' in inputFields[index] && (
                    <small className="w-100">
                      click&nbsp;
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href={inputFields[index]['fileURL']}
                      >
                        here
                      </a>
                      &nbsp;to view the current file.
                    </small>
                  )}
                </Col>

                {!('pk' in inputFields[index]) && (
                  <Col md={4} xs={24}>
                    <Button
                      onClick={() => {
                        removeFields(index);
                        remove(field.name);
                      }}
                    >
                      Remove
                    </Button>
                  </Col>
                )}
              </Row>
            ))}

            <Row gutter={[8, 8]}>
              <Col>
                <Form.Item>
                  <Button
                    onClick={() => {
                      addFields();
                      add();
                    }}
                  >
                    Add More
                  </Button>
                </Form.Item>
              </Col>

              <Col>
                <Button htmlType="submit">Save Changes</Button>
              </Col>
            </Row>
          </>
        )}
      </Form.List>
    </Form>
  );
};

export default RelatedDocsForm;
